import { Stack } from '@vtex/admin-ui'
import { FormState, Select } from '@vtex/admin-ui-form'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { messages } from '../../messages'
import { UtmsType } from '../CreateCoupon'

type Props = {
  utms: UtmsType
  className?: string
  form: FormState
}

export function Utms(props: Props) {
  const { utms, className, form } = props

  const { $t } = useIntl()

  const filledKeys = Object.keys(utms).filter((key) => utms[key].length > 0)

  useEffect(() => {
    Object.keys(utms).forEach((key) => {
      form.setValue(key, utms[key][0] ?? '')
    })
  }, [form, utms])

  return (
    <Stack className={className} fluid space="$space-5">
      {filledKeys.map((utmKey) => (
        <Select
          name={utmKey}
          state={form}
          key={utmKey}
          label={$t(messages.editor.utm[utmKey])}
        >
          {utms[utmKey].map((utm) => (
            <option key={utm} value={utm}>
              {utm}
            </option>
          ))}
        </Select>
      ))}
    </Stack>
  )
}
